import { Container, Box, Grid } from '@material-ui/core';
import React from 'react';

const Projects = () => {
    return (
        <Box data-aos="fade-down" sx={{ mt: 4 }} id='projects'>
            <h1>My <span className='textColor'>Projects</span></h1>
            <Container data-aos="fade-down">
                <hr />
                <Grid className='projects' style={{ display: 'flex', flexDirection: 'column', rowGap: '50px', paddingBottom: '100px' }}>
                    {/* <iframe src="https://assignment-12-niche-web.web.app/" title="description"></iframe>
                    <iframe src="https://assignment-12-niche-web.web.app/" title="description"></iframe>
                    <iframe src="https://assignment-12-niche-web.web.app/" title="description"></iframe>
                    <iframe src="https://assignment-12-niche-web.web.app/" title="description"></iframe> */}
                    <Grid>
                        <div style={{ textAlign: 'start', marginBottom: '20px' }}>
                            <h4>Niche Product Website (MERN Stack)</h4>
                        </div>

                        <iframe src="https://friendly-jennings-e90b0e.netlify.app/" title="description"></iframe></Grid>
                    <Grid >
                        <div style={{ textAlign: 'start', marginBottom: '20px' }}>
                            <h4>Healthcare Related Website (React Authentication)</h4>
                        </div>
                        <iframe src="https://friendly-leakey-37ef00.netlify.app/"
                            title="description"></iframe></Grid>
                    <Grid >
                        <div style={{ textAlign: 'start', marginBottom: '20px' }}>
                            <h4>Product Checkout Website (JavaScript)</h4>
                        </div>
                        <iframe src="https://sad-franklin-0f8498.netlify.app/"
                            title="description"></iframe></Grid>
                    <Grid >
                        <div style={{ textAlign: 'start', marginBottom: '20px' }}>
                            <h4>Book Archive (JS & API Integration)</h4>
                        </div>
                        <iframe src="https://gracious-wing-da5c51.netlify.app/" title="meow"></iframe></Grid>
                </Grid>
                {/* <Grid container spacing={4}>
                    <Grid item xs={12} md={6}>
                        <iframe style={{ resize: 'horizontal', width: '100%', height: '100%' }} src="https://assignment-12-niche-web.web.app/" title="description"></iframe>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <iframe style={{ resize: 'horizontal', width: '100%', height: '100%' }} src="https://assignment-12-niche-web.web.app/" title="description"></iframe>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <iframe style={{ resize: 'vertical', width: '100%', height: '100%' }} src="https://assignment-12-niche-web.web.app/" title="description"></iframe>
                    </Grid>
                </Grid> */}
            </Container>
        </Box >
    );
};

export default Projects;